import { c as _c } from "react/compiler-runtime";
import React from "react";
import Svg from "../Svg";
const Icon = props => {
  const $ = _c(9);
  const {
    color,
    width,
    height
  } = props;
  const t0 = width || 27;
  const t1 = height || 25;
  const t2 = color || "#1D2939";
  let t3;
  if ($[0] !== t2) {
    t3 = <line x1="1.29289" y1="24.0457" x2="23.7985" y2="1.54014" stroke={t2} strokeWidth="2" />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = color || "#1D2939";
  let t5;
  if ($[2] !== t4) {
    t5 = <line x1="2.96004" y1="1.29289" x2="25.4656" y2="23.7985" stroke={t4} strokeWidth="2" />;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t0 || $[5] !== t1 || $[6] !== t3 || $[7] !== t5) {
    t6 = <Svg width={t0} height={t1} viewBox="0 0 27 25" stroke="none">{t3}{t5}</Svg>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t3;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};
export default Icon;